import play from "../../assets/play.png";
import playHover from "../../assets/playHover.png";
import easy from "../../assets/easy.png";
import easyHover from "../../assets/easyHover.png";
import medium from "../../assets/medium.png";
import mediumHover from "../../assets/mediumHover.png";
import hard from "../../assets/hard.png";
import hardHover from "../../assets/hardHover.png";
import { useState } from "react";

const Play = (props) => {
  return (
    <div
      style={{
        position: "absolute",
        width: props.width,
        height: props.height,
        color: "white",
        fontSize: "large",
        fontWeight: "700",
        zIndex: 2,
      }}
      className="d-flex flex-column justify-content-center align-items-center"
    >
      <div className="d-flex flex-row justify-content-center align-items-center mb-3">
        <button
          id={"easy"}
          className="lvl-button"
          onClick={() => {
            props.setSpeed(0.8);
          }}
          style={{ padding: 20, width: 260, margin: 10 }}
        >
          Easy
        </button>
        <button
          id={"medium"}
          className="lvl-button"
          onClick={() => {
            props.setSpeed(1.5);
          }}
          style={{ padding: 20, width: 260, margin: 10 }}
        >
          Medium
        </button>
        <button
          id={"hard"}
          className="lvl-button"
          onClick={() => {
            props.setSpeed(2.2);
          }}
          style={{ padding: 20, width: 260, margin: 10 }}
        >
          Hard
        </button>
      </div>
      <button onClick={props.startGame} className="core-button py-1 px-1">
        <img
          src={play}
          onMouseOver={(e) => {
            e.currentTarget.src = playHover;
          }}
          onMouseOut={(e) => {
            e.currentTarget.src = play;
          }}
          alt="play"
        ></img>
      </button>
      <span
        style={{
          fontSize: "medium",
          fontWeight: "500",
          zIndex: 2,
        }}
        className="mt-4 text"
      >
        Press (SPACE) or (ESC) to finish training
      </span>
    </div>
  );
};

export default Play;
